module.exports = __webpack_public_path__ + "img/paxdrive.08f519e9.png";